"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mappingCustomersTableConf = void 0;
var FooterCounterWithWord_1 = __importDefault(require("containers/TableMaker/components/FooterCounterWithWord"));
var constants_1 = require("containers/TableMaker/constants");
var populatedDerived_1 = require("utils/selectors/populatedDerived");
var Customer_1 = __importDefault(require("./CellComponents/Customer"));
var MatchLevel_1 = __importDefault(require("./CellComponents/MatchLevel"));
var Status_1 = __importDefault(require("./CellComponents/Status"));
var StatusCounter_1 = __importDefault(require("./FooterComponents/StatusCounter"));
var // XL, LG, MD, SM, XS,
XL = constants_1.CellSize.XL, LG = constants_1.CellSize.LG, MD = constants_1.CellSize.MD, XS = constants_1.CellSize.XS;
exports.mappingCustomersTableConf = {
    headersMap: {
        name: 'Organisation',
        'customer.name': 'Customer',
        matchLevel: 'Match',
        primaryContactName: 'Contact Person',
        primaryContactEmail: '',
    },
    headerTooltip: {
        matchLevel: {
            description: '**Match** indicates how closely the organisation name matches the customer name',
        },
    },
    config: {
        selector: populatedDerived_1.selectPopRechargedOrganizationsWithRecharges,
        defaultSort: { key: 'name', order: 1 },
        strikethroughRule: function (item) { return item.matchStatus === 'skipped'; },
        batchSize: 50,
    },
    row: { hoverable: true },
    sortMapper: {
        matchLevel: Object.fromEntries(['multiple', 'notFound', 'weak', 'similar', 'strong', 'exact'].map(function (v, i) { return [v, i]; })),
        matchStatus: Object.fromEntries(['none', 'skipped', 'confirmed'].map(function (v, i) { return [v, i]; })),
    },
    extractors: {
        primaryContactName: function (item) { var _a, _b; return ((_a = item.customer) === null || _a === void 0 ? void 0 : _a.primaryContactName) || ((_b = item.customer) === null || _b === void 0 ? void 0 : _b.primaryContactEmail); },
        primaryContactEmail: function (item) { var _a, _b; return ((_a = item.customer) === null || _a === void 0 ? void 0 : _a.primaryContactName) ? (_b = item.customer) === null || _b === void 0 ? void 0 : _b.primaryContactEmail : ''; },
        plans: function (item) { var _a; return (_a = item.plans) === null || _a === void 0 ? void 0 : _a.join(' • '); },
        'customer.name': function (item) { var _a; return (item.matchStatus === 'confirmed' || item.matchStatus === 'skipped') ? (_a = item.customer) === null || _a === void 0 ? void 0 : _a.name : undefined; },
    },
    cells: [
        {
            cell: { width: XL, growCell: true, offset: 'left' },
            fields: ['name', 'plans'],
            field: 'name',
            truncate: {},
            footerAggregate: 'count',
            footerAggregateRenderValue: (0, FooterCounterWithWord_1.default)('organisation'),
        },
        {
            cell: { width: XL },
            field: 'customer.name',
            footerAggregate: 'countUniq',
            renderComponent: Customer_1.default,
            footerAggregateRenderValue: (0, FooterCounterWithWord_1.default)('customer'),
            stopPropagation: true,
        },
        {
            cell: { width: MD + XS }, field: 'matchLevel', defaultOrder: -1, renderComponent: MatchLevel_1.default,
        },
        { cell: { width: XL + XS, growCell: true }, fields: ['primaryContactName', 'primaryContactEmail'] },
        {
            cell: { width: LG, isFlexCenter: true },
            field: 'matchStatus',
            renderComponent: Status_1.default,
            footerAggregate: 'countGroups',
            footerAggregateRenderObj: StatusCounter_1.default,
            stopPropagation: true,
        },
    ],
};
